<template>
  <div>
    <div class="page-title">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">{{ $t('assessment_test') }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mt-3 mb-3 pt-5 pb-5 bg-white" style="min-height: 60vh;">
      <div class="row box">
        <div class="col-md-9">
          {{ summary.userName }} 的能力檢測紀錄<br>
          目前檢測次數：{{ summary.examCount }} 次（推定等級：{{ summary.userLevel || 'N/A' }}）

          <score-chart ref="chart" class="mt-1" :chartdata="chartdata" :options="options" />
        </div>
        <div class="col-md-3 left-border">
          <div class="p-5">
            {{ summary.userName }} <br>
            {{ summary.examCount > 0 ? '' : '您尚未進行能力檢測' }}<br>
            <button class="btn btn-success btn-block mt-5 mb-5 w-100 mx-auto" @click.stop.prevent="$router.push('/quiz/start')">前往能力檢測</button>

            <hr />

            <p class="text-left pt-3">
              總分：{{ summary.score || 0 }}分<br><br>
              聽力：{{ summary.listeningScore || 0 }} 分<br><br>
              閱讀：{{ summary.readingScore || 0 }} 分<br><br>
              測驗日期：{{ summary.lastTime ? dateParsing(summary.lastTime) : '- / - / -' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scoreChart from './ScoreChart.vue'
import api from '../store/api'

export default {

  name: 'Quiz',

  components: {
    scoreChart
  },

  data () {
    return {
      summary: null,
      chartdata: {
        labels: [],
        datasets: [
          {
            label: '2019',
            backgroundColor: '#ffb12d',
            data: []
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Score'
            },
            ticks: {
              beginAtZero: true,
              stepSize: 100,
              maxTicksLimit: 9,
              max: 900
            }
          }]
        }
      }
    }
  },

  async mounted () {
    const { data } = await api.get('/Assessment/Summary')

    if (data.status === 'OK') {
      this.summary = data.data
      this.getHistory()
    }
  },

  methods: {
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },

    dateParsing (date) {
      var d = new Date(Date.parse(date))
      return d.getFullYear() + '/' + d.getMonth() + '/' + d.getDate()
    },

    async getHistory () {
      const { data } = await api.get('/Assessment/History')

      if (data.status === 'OK') {
        let self = this
        data.data.forEach((el) => {
          this.chartdata.datasets[0].data.push(el.score)
          this.chartdata.labels.push(self.dateParsing(el.createTime))
        })

        this.$refs.chart.renderChart(this.chartdata, this.options)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/color.scss';

div {
  letter-spacing: 0.2em;
}

.left-border {
  border-left: 1px solid $main-light-color;
}

hr {
  border-color: $main-light-color;
}
</style>



// WEBPACK FOOTER //
// Quiz.vue?520822f8